import { useState } from 'react';

export const useResolutionModalHook = () => {
  const [activeTab, setActiveTab] = useState<number>(0);

  const changeTab = (tab: number) => {
    if (tab !== activeTab) {
      setActiveTab(tab);
    }
  };

  return {
    activeTab,
    changeTab,
  };
};
